export default __webpack_public_path__ + "static/media/papular-urticariap.2b0a2855.pdf";